document.addEventListener('DOMContentLoaded', function() {
  const termsInput = document.querySelector('#agree');
  const expressCheckoutButtons = document.querySelector('.additional-checkout-buttons');

  if (!termsInput) {
    return;
  }

  if(expressCheckoutButtons) termsInput.checked?expressCheckoutButtons.style.opacity=1:expressCheckoutButtons.style.opacity=0;
  if(expressCheckoutButtons) termsInput.checked?expressCheckoutButtons.style.visibility="visible":expressCheckoutButtons.style.visibility="hidden";
  termsInput.addEventListener('click', function() {
      if(expressCheckoutButtons) termsInput.checked?expressCheckoutButtons.style.opacity=1:expressCheckoutButtons.style.opacity=0;
      if(expressCheckoutButtons) termsInput.checked?expressCheckoutButtons.style.visibility="visible":expressCheckoutButtons.style.visibility="hidden";
  })
});
